module.exports = __webpack_public_path__ + "static/media/hwsubmit.04957a22.png";